export interface PopularPair {
  from: string;
  to: string;
  fromName: string;
  toName: string;
  label: string;
}

// SEO landing pages — each generates a route /exchange/:from-to-:to
export const POPULAR_PAIRS: PopularPair[] = [
  { from: 'btc', to: 'usdt_trx', fromName: 'Bitcoin', toName: 'Tether (TRON)', label: 'BTC → USDT' },
  { from: 'eth', to: 'btc', fromName: 'Ethereum', toName: 'Bitcoin', label: 'ETH → BTC' },
  { from: 'btc', to: 'eth', fromName: 'Bitcoin', toName: 'Ethereum', label: 'BTC → ETH' },
  { from: 'usdt_trx', to: 'btc', fromName: 'Tether (TRON)', toName: 'Bitcoin', label: 'USDT → BTC' },
  { from: 'sol', to: 'btc', fromName: 'Solana', toName: 'Bitcoin', label: 'SOL → BTC' },
  { from: 'xmr', to: 'btc', fromName: 'Monero', toName: 'Bitcoin', label: 'XMR → BTC' },
  { from: 'ltc', to: 'btc', fromName: 'Litecoin', toName: 'Bitcoin', label: 'LTC → BTC' },
  { from: 'bnb', to: 'usdt_trx', fromName: 'BNB', toName: 'Tether (TRON)', label: 'BNB → USDT' },
  { from: 'eth', to: 'usdt_eth', fromName: 'Ethereum', toName: 'USDC (ETH)', label: 'ETH → USDC' },
];

export interface FeaturedCoin {
  ticker: string;
  name: string;
  symbol: string;
  blurb: string;
}

export const FEATURED_COINS: FeaturedCoin[] = [
  { ticker: 'btc', name: 'Bitcoin', symbol: 'BTC', blurb: 'The original store-of-value cryptocurrency and the most liquid trading pair on ShieldMyAss.' },
  { ticker: 'eth', name: 'Ethereum', symbol: 'ETH', blurb: 'Programmable money powering DeFi, NFTs and the majority of token swaps.' },
  { ticker: 'sol', name: 'Solana', symbol: 'SOL', blurb: 'High-throughput Layer-1 known for fast finality and low transaction fees.' },
  { ticker: 'xmr', name: 'Monero', symbol: 'XMR', blurb: 'Privacy-first cryptocurrency with mandatory ring-signature obfuscation.' },
  { ticker: 'ltc', name: 'Litecoin', symbol: 'LTC', blurb: 'Bitcoin\'s silver — fast confirmations and broad wallet support since 2011.' },
  { ticker: 'bnb', name: 'BNB', symbol: 'BNB', blurb: 'Native asset of the BNB Chain ecosystem and a top exchange token.' },
  { ticker: 'usdt_trx', name: 'Tether (TRON)', symbol: 'USDT', blurb: 'The most adopted dollar stablecoin, cheaply transferable on the TRON network.' },
  { ticker: 'usdc_eth', name: 'USD Coin (Ethereum)', symbol: 'USDC', blurb: 'Fully-backed dollar stablecoin issued by Circle on Ethereum.' },
  { ticker: 'xaut', name: 'Tether Gold', symbol: 'XAUT', blurb: 'One ounce of physical gold, tokenised and redeemable on-chain.' },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const FAQS: FaqItem[] = [
  {
    q: 'Is ShieldMyAss really no-KYC?',
    a: 'Yes. We never ask for your identity documents, email, or phone number. ShieldMyAss uses ChangeNOW as its liquidity partner, and ChangeNOW operates every exchange. Identity verification is not required for standard amounts. Your payout address is the only information we need.',
  },
  {
    q: 'How long does a swap take?',
    a: 'Most swaps settle in 5–30 minutes. The exact time depends on the network you send from and the network you receive on. Bitcoin confirmations take longer than Solana or TRON, for example. You can watch each stage — deposit, confirming, exchanging, sending — live on the status page.',
  },
  {
    q: 'What are the fees?',
    a: 'The rate you see is the rate you get. ShieldMyAss charges 0% on top of the network rate; our partner liquidity provider embeds a small spread (typically 0.25%–0.9%) inside the quoted rate. There are no hidden service fees, no network surcharges, and no subscription.',
  },
  {
    q: 'Do you custody my funds?',
    a: 'No. ShieldMyAss is non-custodial. You send coins to a one-time deposit address generated for your trade, the network swaps them, and the output is sent directly to your wallet. We never hold balances on your behalf.',
  },
  {
    q: 'What happens if I send the wrong coin?',
    a: 'Always verify that the deposit address matches the coin and network you selected. Sending the wrong asset to a deposit address may result in permanent loss. If you make a mistake, contact support immediately with your transaction ID — recovery is sometimes possible but not guaranteed.',
  },
  {
    q: 'Is there a minimum or maximum trade size?',
    a: 'Yes — each pair has a network minimum (often a few dollars equivalent) shown live in the exchange widget. There is no hard maximum, but very large trades may be split across liquidity sources to avoid moving the market.',
  },
  {
    q: 'Which cryptocurrencies are supported?',
    a: 'More than 900 coins across 30+ blockchains, including Bitcoin, Ethereum, Solana, Monero, Litecoin, BNB, Tether (USDT), USD Coin (USDC), Tether Gold (XAUT) and hundreds of ERC-20, BEP-20 and SPL tokens. Browse the full list on the Supported Coins page.',
  },
  {
    q: 'Can I get a refund?',
    a: 'If a swap fails on the network side, the outgoing amount is automatically refunded to the address you came from. If you entered an incorrect payout address, contact support with your transaction ID — recovery depends on whether the payout has already been broadcast.',
  },
];

export const TRUST_POINTS = [
  { icon: 'shield', title: 'No KYC, ever', text: 'Swap without identity checks, emails or accounts.' },
  { icon: 'lock', title: 'Non-custodial', text: 'Funds go straight from your wallet to your wallet.' },
  { icon: 'bolt', title: '5–30 min settlements', text: 'Live status tracking on every single trade.' },
  { icon: 'globe', title: '900+ coins', text: 'Bitcoin to Monero, stablecoins to gold tokens.' },
];

export const STATS = [
  { num: '900', unit: '+', label: 'Coins Supported' },
  { num: '30', unit: '+', label: 'Blockchains' },
  { num: '5', unit: 'min', label: 'Avg Settlement' },
  { num: '0', unit: '%', label: 'KYC Required' },
];
